<script lang="ts">
	import { onMount, type Snippet } from "svelte"

	interface Props {
		expanded?: boolean
		title?: string
		className?: string
		toggle?: (doExpand?: boolean) => void
		header?: Snippet<[any]>
		content?: Snippet
	}

	let {
		expanded = $bindable(),
		title = undefined,
		className = "",
		header,
		content,
		toggle = $bindable(),
	}: Props = $props()

	let contentHeight: number = $state()
	let contentContainer: HTMLDivElement = $state()

	let resizeObserver: ResizeObserver

	toggle = (expand?: boolean) => {
		expanded = expand ?? !expanded
	}

	function updateContentHeight(div: HTMLDivElement) {
		contentHeight = div.offsetHeight
	}

	function initializeResizeObserver(div: HTMLDivElement) {
		if (!div) return

		if (!resizeObserver)
			resizeObserver = new ResizeObserver((entries) => {
				const entry = entries[0]
				updateContentHeight(entry.target as HTMLDivElement)
			})

		resizeObserver.observe(contentContainer)
	}

	$effect(() => {
		if (contentContainer) initializeResizeObserver(contentContainer)
	})
</script>

<div class="collapsible-section {className} {expanded ? 'section-expanded' : ''}" {title}>
	<div
		class="section-header"
		onclick={(e) => {
			e.stopPropagation()
			toggle()
		}}
	>
		{@render header?.({ isExpanded: expanded })}
	</div>
	<div class="collapsible-section-body" style="height: {expanded ? contentHeight : 0}px;">
		<div bind:this={contentContainer} class="content">
			{@render content?.()}
		</div>
	</div>
</div>

<style>
	.section-header {
		position: relative;
		width: 100%;
		display: flex;
		align-items: start;
		cursor: pointer;
	}

	.collapsible-section {
		position: relative;
		width: 100%;
	}

	.collapsible-section-body {
		position: relative;
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		width: 100%;
		overflow: hidden;
		height: 0px;
		transition: height 250ms;
	}
</style>
